import ShiftStatuses from "./ShiftStatuses";

export default ShiftStatuses;
